import { Store } from '@ngxs/store';
import { of } from 'rxjs';
import { inject } from '@angular/core';
import { delay, switchMap } from 'rxjs/operators';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../service';
import { UserState } from '../state';

export const AuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const store = inject(Store);
  const router = inject(Router);

  return of(true);

  // return authService.isAuthenticated$.pipe(
  //   delay(500), // Needed because of the delay of setting the state after initial data is loaded
  //   switchMap(isAuthenticated => {
  //     if (isAuthenticated) {
  //       const user = store.selectSignal(UserState.user);
  //       if (!user().isDICMember && !state.url.includes('no-access')) {
  //         router.navigate(['no-access']);
  //         return of(false);
  //       } else if (route?.data?.routeRoles?.includes('admin')) {
  //         if (user()?.isAdmin) {
  //           return of(true);
  //         } else {
  //           router.navigate(['translation-editor']);
  //           return of(false);
  //         }
  //       } else if (route?.data?.routeRoles?.includes('nonDICMember')) {
  //         if (user()?.isDICMember) {
  //           router.navigate(['translation-editor']);
  //           return of(false);
  //         } else {
  //           return of(true);
  //         }
  //       }
  //       return of(true);
  //     } else {
  //       authService.login(state.url);
  //       return of(false);
  //     }
  //   })
  // );
};
